import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { GetEnumsUseCase } from '@app/application/use-cases/common/get-enums.use-case';
import { GetInputTypeMappingUseCase } from '@app/application/use-cases/common/get-input-type-mapping.use-case';
import { CommonEnum, InputTypeMapping } from '@app/domain/models';
import {
  setEnumsAction,
  setInputTypeMappingAction,
} from '@app/state/system/system.actions';
import { Store } from '@ngrx/store';
import { firstValueFrom, of } from 'rxjs';

// Resolves to true after enums are loaded; never blocks navigation on error
export const commonEnumsResolver: ResolveFn<boolean> = () => {
  const getEnumsUseCase = inject(GetEnumsUseCase);
  const getInputTypeMappingUseCase = inject(GetInputTypeMappingUseCase);
  const store = inject(Store);
  firstValueFrom(getEnumsUseCase.execute()).then((response: CommonEnum) => {
    // Set to store
    console.log('commonEnumsResolver - enums', response);
    store.dispatch(setEnumsAction({ enums: response as CommonEnum }));
  });
  firstValueFrom(getInputTypeMappingUseCase.execute()).then(
    (response: InputTypeMapping[]) => {
      // Set to store
      console.log('commonEnumsResolver - inputTypeMapping', response);
      store.dispatch(setInputTypeMappingAction({ inputTypeMapping: response }));
    }
  );
  return of(true);
};
